import { useMutation } from "@tanstack/react-query";

import useMeetingStore from "@store/useMeetingStore";
import meetingService from "@services/meeting.service";
import { useBugsnagErrorHandler } from "@hooks/useBugsnagErrorHandler";
import { DisconnectedError } from "@app-types/errors";
import { ERROR_STRINGS } from "@config/messages";
import { CREATE_MEETING_OBJECT_MUTATION_KEY } from "@config/query";
import { CreateMeetingObjectRequest } from "@app-types/requests.type";

export function useCreateMeetingObject(onError?: () => void) {
  const { notifyBugsnag } = useBugsnagErrorHandler();
  const { meetingId } = useMeetingStore();

  return useMutation({
    mutationKey: [CREATE_MEETING_OBJECT_MUTATION_KEY, meetingId],
    mutationFn: async (data: CreateMeetingObjectRequest) => {
      return await meetingService.createMeetingObject(meetingId, data);
    },
    onSuccess: () => {},
    onError: (error) => {
      if (error instanceof DisconnectedError) return;
      notifyBugsnag(error, ERROR_STRINGS.CREATE_MEETING_OBJECT);
      onError?.();
    },
  });
}
